import Login from './subviews/login';
import RegisterSendOTP from './subviews/register-send-otp';
import Guest from './subviews/guest';
import CreateAccount from './subviews/create-account';

export default class LoginView {
    constructor(parent) {
        this.parent = parent;
        this.el = parent.el.querySelector('.login-view');
        this.login = new Login(this);
        this.registerSendOTP = new RegisterSendOTP(this);
        this.guest = new Guest(this);
        this.createAccount = new CreateAccount(this);
    }

    show() {
        this.el.classList.remove('hide');
        if (this.parent.params?.tab === 'register') {
            this.login.hide();
            this.registerSendOTP.show();
        } else {
            this.login.show();
            this.registerSendOTP.hide();
        }

        if (this.parent.params?.guest) {
            this.guest.show();
        } else {
            this.guest.hide();
        }
    }

    hide() {
        this.el.classList.add('hide');
    }

    close() {
        this.parent.hide();
    }
}
